import React from 'react';

import Delete from 'Components/Partials/Modals/Delete';
import {IndexTable} from 'Components/Utilities';

import AdminLayout from 'Pages/Admin/AdminLayout';

import PollsApi from 'Services/Api/Admin/MainStage/Polls';

export default class Polls extends React.Component {
    /**
     * @var columns
     * @type {array}
     */
    columns = [
        {
            label: 'Question',
            value: 'question',
            type: 'string',
            orderable: true,
        },
    ];

    /**
     * @var state
     */
    state = {
        sessionId: this.props.match.params.session
    };

    /**
     * @method getRowActions
     * @param {object} item
     */
    getRowActions = (item) => {
        const {sessionId} = this.state;

        return [
            {
                type: "link",
                to: `/admin/main-stage/polls/${sessionId}/store/${item.id}`,
                text: "Edit"
            },
            {
                type: "link",
                to: `/admin/main-stage/polls/${sessionId}/results/${item.id}`,
                text: "Results"
            },
            {
                type: "modalTrigger",
                component: Delete,
                props: {
                    itemName: 'session',
                    itemId: item.id,
                    onDeleteApi: (itemId, event, successStatus, config) => PollsApi.delete({
                        session: sessionId,
                        poll: itemId
                    }, event, successStatus, config)
                },
                text: 'Delete'
            }
        ];
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {sessionId} = this.state;

        return (
            <AdminLayout title="Main Stage - Polls">
                <IndexTable
                    columns={this.columns}
                    displaySearchBar={false}
                    storeLink={`/admin/main-stage/polls/${sessionId}/store`}
                    loadDataCallback={(data) => PollsApi.get({
                        session: sessionId
                    }, data)}
                    rowActions={this.getRowActions}
                    eventApi={PollsApi}
                />
            </AdminLayout>
        );
    }
}
